"use client";

import { useAtomValue } from "jotai";
import { isOnlineAtom, useInternetConnectivity } from "@/services/internetConnectivity";
import cn from "@/utils/class-names";
import { useEffect, useState } from "react";

export default function InternetConnectivityRibbon() {
  const isOnline = useInternetConnectivity(); // This hook also sets up the listeners
  const isOnlineValue = useAtomValue(isOnlineAtom);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || isOnlineValue) return null;

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-[9999] flex items-center justify-center bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-lg transition-all duration-300 animate-in slide-in-from-bottom"
      )}
    >
      <span className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2v4" />
          <path d="m4.93 4.93 2.83 2.83" />
          <path d="M2 12h4" />
          <path d="m4.93 19.07 2.83-2.83" />
          <path d="M12 18v4" />
          <path d="m19.07 19.07-2.83-2.83" />
          <path d="M22 12h-4" />
          <path d="m19.07 4.93-2.83 2.83" />
        </svg>
        Your internet connection is down. Please check your network.
      </span>
    </div>
  );
}
